export enum SanctionStatus {
	Sukurta = 0,
	PerduotaPpts = 1,
	PerduotaVtat = 2,
	Atmesta = 3,
	Isigaliojusi = 4,
	Panaikinta = 5,
	Nebeaktuali = 6,
}

/** The statuses in which the sanction data may still be edited (the backend's `SanctionStateTransitions.IsDataEditable`). */
export const SANCTION_DATA_EDITABLE_STATUSES: readonly SanctionStatus[] = [
	SanctionStatus.Sukurta,
	SanctionStatus.PerduotaPpts,
	SanctionStatus.PerduotaVtat,
	SanctionStatus.Atmesta,
];

/**
 * The statuses in which a sanction assigned to a specialist still waits for that specialist.
 * Mirrors BE `EmployeeWorkload.AssignedSanctionStatuses`.
 */
export const ASSIGNED_SANCTION_STATUSES: readonly SanctionStatus[] = [
	SanctionStatus.PerduotaPpts,
	SanctionStatus.Atmesta,
] as const;

/** The statuses a move enters only with a reason (the backend's `SanctionStateTransitions.IsReasonRequired`). */
export const SANCTION_REASON_STATUSES = [SanctionStatus.Atmesta, SanctionStatus.Panaikinta] as const;

/** A status a move enters only with a reason. */
export type SanctionReasonStatus = (typeof SANCTION_REASON_STATUSES)[number];

/**
 * A status a user may move a sanction into: moves into `Nebeaktuali` are made by system rules and no move enters
 * `Sukurta` (the backend's `SanctionStateTransitions.IsUserInitiated`).
 */
export type SanctionUserTransitionTarget = Exclude<SanctionStatus, SanctionStatus.Sukurta | SanctionStatus.Nebeaktuali>;
